import { combineReducers } from 'redux';
import highlightReducer from './highlightReducer';
import flashSaleReducer from './flashSaleReducer';
import bestSellingReducer from './bestSellingReducer';
import mostPopularReducer from './mostPopularReducer';

const reducers = combineReducers({
  highlight: highlightReducer,
  flashSale: flashSaleReducer,
  bestSelling: bestSellingReducer,
  mostPopularSearches: mostPopularReducer
})

export default reducers;